'use strict';

angular.module('shiftTraderApp')
  .service('WorkPeriodStore', ['$q', 'Session', 'WorkPeriods', '$rootScope', function($q, Session, WorkPeriods, $rootScope) {
    var currentTime;
    var CACHE_EXP_IN_SECONDS = 60 * 5;
    var that = this;

    this.flush = function() {
      var i;

      that.reverseIndex = {};
      that.dataFetched = {
        2013: [],
        2014: [],
        2015: [],
        2016: [],
        2017: [],
        2018: [],
        2019: [],
        2020: [],
        2021: [],
        2022: [],
        2023: [],
        2024: [],
        2025: [],
        2026: [],
        2027: [],
        2028: [],
        2029: [],
        2030: []
      };

      //first levels of keys is integer year
      //next level is an array of array, each index corresponding to day in year
      that.wpIndexByStartDate = {
        2013: [],
        2014: [],
        2015: [],
        2016: [],
        2017: [],
        2018: [],
        2019: [],
        2020: [],
        2021: [],
        2022: [],
        2023: [],
        2024: [],
        2025: [],
        2026: [],
        2027: [],
        2028: [],
        2029: [],
        2030: []
      };

      _.forEach(that.wpIndexByStartDate, function(val, year) {
        for (i = 0; i <= 366; i++) { // create 367 arrays, never use array index 0
          that.wpIndexByStartDate[year].push([]);
          that.dataFetched[year].push(null);
        }
      });
    };

    $rootScope.$on('flushCaches', function() {
      that.flush();
    });

    this.flush();

    this.categorizeWorkPeriods = function(workPeriods) {
      var deferred = $q.defer();
      _.each(workPeriods, function(wp) {
        //console.log(wp);
        //console.log(wp.start_time.format());
        //console.log(wp.start_time.dayOfYear());
        if (!that.replaceById(wp)) {
          that.wpIndexByStartDate[wp.start_time.year()][wp.start_time.dayOfYear()].push(wp);
        }

        that.reverseIndex[wp.id] = [wp.start_time.year(), wp.start_time.dayOfYear()];
      }, that);
      deferred.resolve(workPeriods);

      return deferred.promise;
    };

    this.addWorkPeriods = function(workPeriods) {
      return that.categorizeWorkPeriods(workPeriods);
    };

    this.addWorkPeriod = function(workPeriod) {
      return that.addWorkPeriods([workPeriod]);
    };

    this.isCacheValid = function(year, dayOfYear) {
      var x = !_.isNull(that.dataFetched[year][dayOfYear]) &&
        ((that.dataFetched[year][dayOfYear] + CACHE_EXP_IN_SECONDS) > currentTime);
      return x;
    };

    this.getWorkPeriodsBetween = function(startTime, endTime, extraParams) {
      currentTime = moment.utc().unix();
      var deferred = $q.defer();

      var startYear = startTime.year();
      var endYear = endTime.year();

      var startDayOfYear = startTime.dayOfYear();
      var endDayOfYear = endTime.dayOfYear();

      var unloadedDates = {
        2013: [],
        2014: [],
        2015: [],
        2016: [],
        2017: [],
        2018: [],
        2019: [],
        2020: [],
        2021: [],
        2022: [],
        2023: [],
        2024: [],
        2025: [],
        2026: [],
        2027: [],
        2028: [],
        2029: [],
        2030: [],
      };
      var i;
      // two dates in the same year
      if ( (endDayOfYear >= startDayOfYear) && (startYear === endYear) ) {
        for(i = startDayOfYear; i <= endDayOfYear; i++) {
          if (!that.isCacheValid(startYear, i)) {
            unloadedDates[startYear].push(i);
          }
        }
      } else {
        // two dates not in the same year...

        // first, go to end of year in first year
        for (i = startDayOfYear; i <= 366; i++) {
          if (!that.isCacheValid(startYear, i)) {
            unloadedDates[startYear].push(i);
          }
        }

        // then go from day 1 of last year to appropriate day
        for(i = 1; i <= endDayOfYear; i++) {
          if (!that.isCacheValid(endYear, i)) {
            unloadedDates[endYear].push(i);
          }
        }
      }

      //find the min and max of the ranges
      var minMaxDatesByYear = {
        2013: [],
        2014: [],
        2015: [],
        2016: [],
        2017: [],
        2018: [],
        2019: [],
        2020: [],
        2021: [],
        2022: [],
        2023: [],
        2024: [],
        2025: [],
        2026: [],
        2027: [],
        2028: [],
        2029: [],
        2030: []
      };

      var allRequests = _.where(_.map(minMaxDatesByYear, function(val, key) {
        if ( unloadedDates[key].length > 0) {
          minMaxDatesByYear[key].push(Math.min.apply(Math, unloadedDates[key]));
          minMaxDatesByYear[key].push(Math.max.apply(Math, unloadedDates[key]));

          //console.log(minMaxDatesByYear[key]);
          var data = {
            start_time: moment.utc().tz(Session.getTimezone()).year(key).dayOfYear(minMaxDatesByYear[key][0]).minutes(0).seconds(0).milliseconds(0).hours(0).toISOString(),
            end_time: moment.utc().tz(Session.getTimezone()).year(key).dayOfYear(minMaxDatesByYear[key][1]).minutes(0).seconds(0).milliseconds(0).hours(0).add(1, 'days').toISOString()
          };
          if (!_.isUndefined(extraParams)) {
            angular.extend(data, extraParams);
          }

          return WorkPeriods.getAll(data)
            .then(function(wps) {
              return that.categorizeWorkPeriods(wps)
                .then(function(result) {
                  var newTimestamp = moment.utc().unix();

                  _.each(unloadedDates[key], function(day) {
                    that.dataFetched[key][day] = newTimestamp;
                  });
                  return result;
                });
              //return wps;
            });

        } else {
          return -1;
        }
      }), function(promise) {
        return promise !== -1;
      });

      if (allRequests.length > 0) {
        $q.all(allRequests)
          .then(function() {
            console.log('Requests received');
            deferred.resolve(that.retrieveWorkPeriodsBetweenDates(startTime, endTime));
          }, function() {
            console.log('workPeriod receive failed!');
            deferred.reject(undefined);
          });
      } else {
        console.log('No requests required to process request for workPeriods');
        deferred.resolve(that.retrieveWorkPeriodsBetweenDates(startTime, endTime));
      }

      return deferred.promise;
    };

    this.retrieveWorkPeriodsBetweenDates = function(startTime, endTime) {
      var result = [];
      var startYear = startTime.year();
      var endYear = endTime.year();
      var i;

      var startDayOfYear = startTime.dayOfYear();
      var endDayOfYear = endTime.dayOfYear();
      if ( (endDayOfYear >= startDayOfYear) && (startYear === endYear) ) {
        for(i = startDayOfYear; i <= endDayOfYear; i++) {
          result.push.apply(result, that.wpIndexByStartDate[startYear][i]);
        }
      } else {
        for (i = startDayOfYear; i <= 366; i++) {
          result.push.apply(result, that.wpIndexByStartDate[startYear][i]);
        }

        for(i = 1; i <= endDayOfYear; i++) {
          result.push.apply(result, that.wpIndexByStartDate[endYear][i]);
        }
      }
      return result;
    };

    this.replaceById = function(workPeriod) {
      var year = workPeriod.start_time.year();
      var dayOfYear = workPeriod.start_time.dayOfYear();

      var idx = _.findIndex(that.wpIndexByStartDate[year][dayOfYear], function(wp) {
        return wp.id === workPeriod.id;
      });

      if (idx > -1) {
        that.wpIndexByStartDate[year][dayOfYear][idx] = workPeriod;
        return true;
      } else {
        return false;
      }
    };

    this.mergeById = function(workPeriod) {
      var year = workPeriod.start_time.year();
      var dayOfYear = workPeriod.start_time.dayOfYear();

      var idx = _.findIndex(that.wpIndexByStartDate[year][dayOfYear], function(wp) {
        return wp.id === workPeriod.id;
      });

      if (idx > -1) {
        that.wpIndexByStartDate[year][dayOfYear][idx] = _.merge(that.wpIndexByStartDate[year][dayOfYear][idx], workPeriod);
        return true;
      } else {
        return false;
      }
    };

    this.updateOrAdd = function(workPeriod) {
      var year = workPeriod.start_time.year();
      var dayOfYear = workPeriod.start_time.dayOfYear();

      var idx = _.findIndex(that.wpIndexByStartDate[year][dayOfYear], function(wp) {
        return wp.id === workPeriod.id;
      });

      if (idx > -1) {
        // we found a match
        that.wpIndexByStartDate[year][dayOfYear][idx] = workPeriod;
        return true;
      } else {
        that.wpIndexByStartDate[year][dayOfYear][idx] = _.merge(that.wpIndexByStartDate[year][dayOfYear][idx], workPeriod);
      }
    };

    this.removeByWorkPeriod = function(workPeriod) {
      var year = workPeriod.start_time.year();
      var dayOfYear = workPeriod.start_time.dayOfYear();

      var idx = _.findIndex(that.wpIndexByStartDate[year][dayOfYear], function(wp) {
        return wp.id === workPeriod.id;
      });

      if (idx > -1) {
        that.wpIndexByStartDate[year][dayOfYear].splice(idx,1);
        delete that.reverseIndex[workPeriod.id];
        return true;
      } else {
        return false;
      }
    };

    this.getRecordById = function(id) {
      var deferred = $q.defer();

      if (_.has(that.reverseIndex, id) &&
        that.isCacheValid(that.reverseIndex[id][0], that.reverseIndex[id][1])) {
        var index = 0;
        for (var i = 0; i < that.wpIndexByStartDate[that.reverseIndex[id][0]][that.reverseIndex[id][1]].length; i++) {
          if (that.wpIndexByStartDate[that.reverseIndex[id][0]][that.reverseIndex[id][1]][i].id == id) {
            index = i;
          }
        }
        deferred.resolve(
          that.wpIndexByStartDate[that.reverseIndex[id][0]][that.reverseIndex[id][1]][index]
        );
      } else {
        WorkPeriods.getById(id)
          .then(function(wp) {
            // that.addOrReplaceRecord(wp);
            that.mergeById(wp);
            deferred.resolve(wp);
          }, function(response) {
            deferred.reject(response);
          });
      }

      return deferred.promise;
    }
  }]);
